import React, { useContext } from 'react'
import { UserContext } from '../../../../../App';
import BranchProfile from './BranchProfile';
import BankProfile from './BankProfile';

const Profile = () => {

    const decodedData = useContext(UserContext);

  return (
    <>
        {decodedData?.role === 'admin' && <BranchProfile />}
        {decodedData?.role === 'master_admin' && <BankProfile />}
    </>
  )
}

export default Profile